import {
  TodoForm,
  VEHICLE_SET_TYPES,
} from "features/TodoOploggSidebar/formSchema";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { Dropdown } from "shared/components/forms/Dropdown";
import { FilterChip, Flex } from "shared/components/Spor";
import { toggle } from "shared/utils/objectUtils";

export const VehicleSetOptions = () => {
  const { watch, setValue } = useFormContext<TodoForm>();
  const { t } = useTranslation();

  const selectedValues = watch("vehicleSetTypes") ?? [];
  return (
    <Dropdown
      label={t("Marker med")}
      selectedAmount={selectedValues.length}
      width="100%"
    >
      <Flex flexWrap="wrap" maxWidth="160px" height="fit-content" gap="6px">
        {VEHICLE_SET_TYPES.map(({ value, text }) => (
          <FilterChip
            key={value}
            checked={selectedValues?.includes(value) ?? false}
            onCheckedChange={() =>
              setValue("vehicleSetTypes", toggle(selectedValues, value))
            }
          >
            {text}
          </FilterChip>
        ))}
      </Flex>
    </Dropdown>
  );
};
